module.exports = __webpack_public_path__ + "img/logo.497e21ec.png";